import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {PostDO} from '../../common/data-objects/PostDO';
import {PostsService} from '../../common/services/posts.service';

@Component({
  selector: 'app-search-thumbnail',
  templateUrl: './search-thumbnail.component.html',
  styleUrls: ['./search-thumbnail.component.scss']
})
export class SearchThumbnailComponent implements OnInit, OnChanges {
  @Input() post: PostDO;
  maxTags: string[];
  MAX_TAGS_COUNT = 4;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.video) {
      this.maxTags = this.post.tags.splice(0, this.MAX_TAGS_COUNT);
    }
  }

  getImageUrl(post): string {
    return post.featuredImageSizes ? post.featuredImageSizes.medium : null;
  }

  get postType(): string {
    let prefix = 'activities';
    const categories = this.post.categories;
    if (categories.includes(PostsService.CARTOONS_PAGES)) {
      prefix = 'cartoons';
    } else if (categories.includes(PostsService.COLORING_PAGES)) {
      prefix = 'coloring';
    } else if (categories.includes(PostsService.SONGS_PAGES)) {
      prefix = 'songs';
    } else if (categories.includes(PostsService.BLOG_POSTS)) {
      prefix = 'blog';
    }  else if (categories.includes(PostsService.CRAFTS_PAGES)) {
      prefix = 'crafts';
    } else if (
      categories.includes(PostsService.REVIEW_PAGE) ||
      categories.includes(PostsService.REVIEWS_BOOKS) ||
      categories.includes(PostsService.REVIEWS_OFFLINE_GAMES) ||
      categories.includes(PostsService.REVIEWS_ONLINE_GAMES)
    ) {
      prefix = 'reviews';
    }

    return prefix;
  }

  get postLink(): string[] {
    return ['/', this.postType, this.post.slug];
  }
}
